export const WARNING_POPUP_IMAGE_URL =
  'https://static.rfstat.com/renderforest/images/v2/video-editor-v2/warning.png'

export const ERROR_POPUP_IMAGE_URL =
  'https://s3.us-west-2.amazonaws.com/static.rfstat.com/renderforest/images/v2/video-editor-v2/error-icon.png'
